import {
  NotificationStrategy,
  markAsAccepted,
  markAsRejected,
} from '../../../../shared/services/notification/workflow';
import { resolveAvToDownstreamHandoffDecision } from '../../../npi-steering/services/resolveAvToDownstreamHandoffDecision';
import { finalizeNotificationAction } from './notificationStrategyFinalize';

async function handleAccept({ item }: Parameters<NotificationStrategy['accept']>[0]) {
  const result = await resolveAvToDownstreamHandoffDecision({
    item,
    decision: 'ACCEPT',
  });

  if (!result?.handled) {
    throw new Error('AV_TO_DOWNSTREAM_HANDOFF decision was not handled');
  }

  await markAsAccepted(item.userNotificationId, item.status);
  await finalizeNotificationAction({
    item,
    strategyName: 'avToDownstreamHandoffStrategy',
    action: 'accept',
  });
}

async function handleReject({ item }: Parameters<NotificationStrategy['reject']>[0]) {
  const result = await resolveAvToDownstreamHandoffDecision({
    item,
    decision: 'REJECT',
  });

  if (!result?.handled) {
    throw new Error('AV_TO_DOWNSTREAM_HANDOFF decision was not handled');
  }

  await markAsRejected(item.userNotificationId, item.status);
}

export const avToDownstreamHandoffStrategy: NotificationStrategy = {
  accept: handleAccept,
  reject: handleReject,
};